export const NoteStatus = {
  PRIVATE: {
    value: 1,
    id: 'Private'
  },
  PUBLIC: {
    value: 0,
    id: 'Public'
  }
};